import * as E from 'fp-ts/Either';
import { constFalse, pipe } from 'fp-ts/lib/function';
import qs from 'qs';

interface Location {
  lat: number;
  lng: number;
  address: string;
}

/**
 * Gets a maps link to open the appropriate native maps app on the user's device
 * @param location
 */
export const getMapsLink = (location: Location) => {
  const isIOS = pipe(
    E.tryCatch(
      () => navigator.useAgentData?.platform || navigator.platform || 'unknown',
      () => 'unknown',
    ),
    E.map((platform) =>
      ['iPhone', 'iPad', 'iPod'].some((p) => platform.includes(p)),
    ),
    E.getOrElse(constFalse),
  );

  const query = qs.stringify({
    q: location.address,
    ll: [location.lat, location.lng].join(','),
    z: 14,
  });

  if (isIOS) {
    return `maps://maps.google.com/maps?${query}`;
  }
  /* else use Google */
  return `https://maps.google.com/maps?${query}`;
};
